import { multipleChoiceQuestionsRoutesObj } from "./path";

import type { IRouteMetadataObj } from "@routes/types";
import { createRoute } from "@/routes/utils";
import { IRoleEnum } from "@/interfaces";

const permission = [IRoleEnum.SUPER_ADMIN, IRoleEnum.Teacher];

const multipleChoiceQuestionRouteMetadata: IRouteMetadataObj<
  typeof multipleChoiceQuestionsRoutesObj
> = {
  create: {
    title: "multipleChoiceQuestion.create.title",
    description: "multipleChoiceQuestion.create.description",
    lazy: () => import("@/pages/questions/multipleChoice/form/page"),
    mode: "create",
    type: "inner",
    icon: "AddLine",
    breadcrumbs: [],
    permission,
  },
  edit: {
    title: "multipleChoiceQuestion.edit.title",
    description: "multipleChoiceQuestion.edit.description",
    lazy: () => import("@/pages/questions/multipleChoice/form/page"),
    mode: "edit",
    type: "inner",
    icon: "EditLine",
    breadcrumbs: [],
    permission,
  },
  view: {
    title: "multipleChoiceQuestion.view.title",
    description: "multipleChoiceQuestion.view.description",
    lazy: () => import("@/pages/questions/multipleChoice/form/page"),
    mode: "edit",
    type: "inner",
    icon: "GraduationCapLine",
    breadcrumbs: [],
    permission,
  },
};

export const multipleChoiceQuestionsRoutes = createRoute<
  typeof multipleChoiceQuestionsRoutesObj
>(multipleChoiceQuestionsRoutesObj, multipleChoiceQuestionRouteMetadata);
